export default __webpack_public_path__ + "static/shushing_face-423e6e0598bb644cafc18fdd9ed8ec2c.svg";